import { initialListData, ListData } from "./List";

export interface WorkflowData {
  id: number;
  transactionId: number;
  name: string;
  description: string;
  transactions: ListData;
}

export const initialWorkflowData: WorkflowData = {
  id: 0,
  transactionId: 0,
  name: "",
  description: "",
  transactions: initialListData,
};

export interface WorkflowDetailData {
  id: number;
  workflowId: number;
  roleId: number;
  taskLevel: number;
  statusId: number;
  location: string;
  canSkip: boolean;
  canSend: boolean;
  direction: number;
  isFirst: boolean;
  workflows: WorkflowData;
  transactions: ListData;
  statuses: ListData;
}

export const initialWorkflowDetailData: WorkflowDetailData = {
  id: 0,
  workflowId: 0,
  roleId: 0,
  taskLevel: 0,
  statusId: 0,
  location: "",
  canSkip: false,
  canSend: false,
  direction: 0,
  isFirst: false,
  workflows: initialWorkflowData,
  transactions: initialListData,
  statuses: initialListData,
};
